export default  {
    login: "maqbull",
    id: 54414387,
    node_id: "MDQ6VXNlcjU0NDE0Mzg3",
    avatar_url: "https://avatars.githubusercontent.com/u/54414387?v=4",
    gravatar_id: "",
    url: "https://api.github.com/users/maqbull",
    html_url: "https://github.com/maqbull",
    followers_url: "https://api.github.com/users/maqbull/followers",
    following_url: "https://api.github.com/users/maqbull/following{/other_user}",
    gists_url: "https://api.github.com/users/maqbull/gists{/gist_id}",
    starred_url: "https://api.github.com/users/maqbull/starred{/owner}{/repo}",
    subscriptions_url: "https://api.github.com/users/maqbull/subscriptions",
    organizations_url: "https://api.github.com/users/maqbull/orgs",
    repos_url: "https://api.github.com/users/maqbull/repos",
    events_url: "https://api.github.com/users/maqbull/events{/privacy}",
    received_events_url: "https://api.github.com/users/maqbull/received_events",
    type: "User",
    site_admin: false,
    name: "Mohd Maqbool",
    company: null,
    blog: "",
    location: "India",
    email: null,
    hireable: true,
    bio: "React JS developer , Sometime code in python as well . \r\nCSE 3rd year student who loves to code or live for code . \r\nJavaScript is love and python is crush .",
    twitter_username: null,
    public_repos: 13,
    public_gists: 0,
    followers: 0,
    following: 16,
    created_at: "2019-08-22T17:50:39Z",
    updated_at: "2021-04-17T15:57:50Z"
  }